const en = {
  loading: 'Loading...',
  close: 'Close',
  menu: 'Menu',
  search: 'Search',
  contextSearchHint: 'Ask in your own words — we suggest Bible verses.',
  contextSearchPlaceholder: 'e.g. forgiveness, faith in trials…',
  contextSearchSearching: 'Searching…',
  contextSearchGoToRef: 'Open in Bible',
  contextSearchClear: 'Clear search',
  bookmarks: 'Bookmarks',
  createBookmark: 'Create bookmark',
  addBookmark: 'Add',
  addingBookmark: 'Adding…',
  addBookmarkTitle: 'Add bookmark',
  history: 'History',
  settings: 'Settings',
  bible: 'Bible',
  chat: 'Chat',
  chatActionLabel: 'Explanation',
  verseInsightButton: 'Explain',
  dailyVerse: 'Verse of the day',
  homeInsightExplain: 'Explanation',
  guestInsightLimit: 'Today’s free insight limit is used up. Sign in with email for full access.',
  exitFocusMode: 'Exit focus',
  chatVerseShowFull: 'Show verse text',
  chatVerseCollapse: 'Hide verse text',
  chatUserQuestionPrefix: 'User question:',
  chatVerseContextLabel: 'Question about verse:',
  chatEmptyWithVerse: 'Enter your question below.',
  chatEmptyGeneral: 'Ask a question about the Bible.',
  chatStreamingHint: 'The answer will stream like in a chat.',
  chatLoadingAnswer: 'Preparing the answer...',
  chatFollowUpDeep: 'Dive deeper',
  chatFollowUpKeyThought: 'Key idea',
  chatFollowUpSimple: 'Simple and clear',
  chatFollowUpSimpleShort: 'Simple',
  chatApplicationShort: 'Practice',
  chatFollowUpNewQuestion: 'New question',
  chatComposerPlaceholderVerse: 'Your question about this verse…',
  chatSend: 'Send',
  chatSuggestLabel: 'You could ask',
  chatSuggestMain: 'What is the main point here?',
  chatSuggestSimple: 'Explain it in simple words',
  chatSuggestApply: 'How do I apply this today?',
  chatComposerPlaceholderGeneral: 'For example: how to understand James 1:2?',
  chatTabsRowAria: 'Saved chats',
  chatSessionUntitled: 'New chat',
  chatTabNewQuestion: 'New question',
  chatTabCloseAria: 'Close chat tab',
  chatTabNew: 'New chat',
  linkLabel: 'Link',
  chapterWord: 'Chapter',
  psalmWord: 'Psalm',
  verseWord: 'Verse',
  bookWord: 'Book',
  home: 'Home',
  bookChapterCount: '{count} chapters',
  bookChapterCount_one: '{count} chapter',
  verseImageMayTake: 'Generation may take 10-30 sec',
  verseImageNoIllustration: 'There is no illustration for this verse in the collection yet.',
  application: 'Application',
  applicationEmpty: 'Application is not filled in yet.',
  chapterSelectorSearchPlaceholder: 'Search book and chapter...',
  chapterSelectorSearchLabel: 'Search books and chapters',
  chapterSelectorDescriptionBookMissing: 'Could not load description: no book selected',
  chapterSelectorNothingFound: 'Nothing found. Try a book name, abbreviation, or chapter number.',
  chapterCountCompact: '{count} chapters',
  chapterCountCompact_one: '{count} chapter',
  bookSectionLabel: 'Book section',
  bookmarkAuthRequired: 'Authentication is required. Please sign in again.',
  signInRequiredForAi: 'Sign in with email to use explanations, chat, search, and illustrations.',
  bookmarkAddError: 'Could not add bookmark',
  bookmarkLocationLabel: 'Location:',
  bookmarkTitleOptional: 'Title (optional)',
  bookmarkTitlePlaceholder: 'Enter bookmark title',
  bookmarkTitleCounter: '{count}/{max} characters',
  bookmarksLoading: 'Loading bookmarks...',
  bookmarksEmpty: 'No bookmarks yet',
  bookmarksLoadError: 'Error loading bookmarks',
  bookmarkUntitled: 'Untitled',
  bookmarkChoose: 'Which bookmark to move here?',
  bookmarkSelectTitle: 'Choose this bookmark',
  bookmarkSelect: 'Choose',
  bookmarkGoTitle: 'Go to bookmark',
  bookmarkDeleteTitle: 'Delete bookmark',
  bookmarkDeleteConfirm: 'Delete bookmark?',
  bookmarkDeleteError: 'Error deleting bookmark',
  bookmarkMoveError: 'Error moving bookmark',
  savedTitle: 'Saved',
  savedItemsTitle: 'Verses & chapters',
  ribbonsTitle: 'Bookmarks',
  savedEmpty: 'Tap a verse → “Save”. In Telegram, send the bot “🔖 Rom 8” or tap “Save” under the morning message.',
  ribbonsEmpty: 'A bookmark marks where you stopped. Tap the bookmark icon in the chapter header.',
  saveVerse: 'Save',
  unsaveVerse: 'Remove from saved',
  savedDone: 'Saved',
  savedRemoved: 'Removed from saved',
  undoAction: 'Undo',
  saveChapter: 'Save chapter',
  chapterSaved: 'Chapter saved',
  newRibbon: 'New bookmark',
  ribbonMoveHere: 'Here',
  ribbonMovedHere: 'Bookmark “{name}” is here now',
  historyClear: 'Clear',
  historyClearConfirm: 'Clear all history?',
  historyEmpty: 'History is empty',
  timeJustNow: 'just now',
  timeMinutesAgo: '{count} min ago',
  timeHoursAgo: '{count} h ago',
  chapters: 'Chapters',
  description: 'Description',
  retry: 'Try again',
  interpretation: 'Interpretation',
  copyLink: 'Copy link',
  linkCopied: 'Link copied!',
  copyManually: 'Copy the link manually',
  error: 'Error',
  verse: 'Verse',
  openVerseMenu: 'open actions menu',
  parallels: 'Parallels',
  openPassage: 'Open',
  illustration: 'Illustration',
  moreActions: 'More',
  verseActions: 'Verse actions',
  share: 'Share',
  note: 'Note',
  cancelAction: 'Cancel',
  chapterSelect: 'Chapter selection',
  previousChapter: 'Previous chapter',
  nextChapter: 'Next chapter',
  noData: 'No data',
  terms: 'Terms',
  theology: 'Theology',
  christConnection: 'Connection to Christ',
  typology: 'Typology',
  crossReferences: 'Cross references',
  chatReferencesLabel: 'References',
  faqByText: 'Frequently asked questions from the text',
  noFaq: 'No FAQ data for this verse',
  immediateContext: 'Immediate context',
  contextTab: 'Context',
  bookContext: 'Book context',
  biblicalContext: 'Biblical context',
  culture: 'Culture',
  historical: 'History',
  noCultureHistory: 'No culture and history data',
  faqTab: 'Questions',
  studyMeaning: 'Meaning',
  studySimple: 'Simply',
  studyKeyIdea: 'Key idea',
  studyAsk: 'Ask about this verse…',
  botChatSent: 'The answer is typing in the bot chat',
  botChatOpen: 'Open',
  studyToolsAria: 'Verse study',
  noSimple: 'Could not explain it more simply yet. Please try again.',
  faqTabTitle: 'Questions about the text',
  originalTab: 'Original',
  originalLanguage: 'Original',
  noOriginal: 'No original language data',
  principle: 'Principle',
  today: 'Today',
  noApplicationYet: 'Application is not filled for this verse yet.',
  analyzingScripture: 'Analyzing the Scripture passage...',
  mayTakeMinutes: 'This may take a few minutes',
  loadingBookDescription: 'Loading book description...',
  mayTakeSeconds: 'This may take a few seconds',
  aboutBook: 'About the book',
  verseExplain: 'Explanation',
  verseInsightDialogAria: 'Verse breakdown',
  verseInsightExpand: 'Full breakdown in chat',
  verseInsightAskQuestion: 'Ask a question',
  verseInsightThreadTitle: 'Follow-ups',
  verseInsightVerseExpandAria: 'Expand verse text',
  verseInsightVerseCollapseAria: 'Collapse verse text',
  verseOriginal: 'Original',
  chatApplyLifeLabel: 'Apply to real life',
  chatApplyLifePrompt: 'How can this be applied to real life?',
  appLanguage: 'Language',
  readingSettingsTabDisplay: 'Display',
  readingFont: 'Reading font',
  settingsTitle: 'Settings',
  settingsLogout: 'Log out',
  loginByEmailForFeatures: 'Sign in with email to access features',
  loginOpenedInTelegram: 'Opened in Telegram',
  loginTelegramAutoAuth: 'Authorization should happen automatically',
  loginCheckEmailLinkSent: '📩 Check your email address, the link was sent successfully.',
  loginSendAgain: 'Send again',
  loginSending: 'Sending...',
  loginByEmailButton: '✉️ Sign in with email',
  loginTelegramRefreshHint: 'If authorization did not happen automatically, refresh the page',
  loginEmailReturnHint: 'After sign-in, the email link will open the app with the same return path.',
  loginSuccessByLink: 'Signed in via link',
  loginLinkInvalidOrExpired: 'Link is invalid or expired',
  loginSuccess: 'Signed in',
  loginError: 'Sign-in error',
  loginEnterEmail: 'Enter email',
  loginSendLinkFailed: 'Failed to send the link',
  settingsBackAria: 'Back',
  settingsLanguageHelp: 'Choose the interface and translation language. Interpretation will use the selected language.',
  settingsReadingFontHelp: 'Choose the typeface used for Bible verse text while reading.',
  settingsTranslationsLabel: 'Translations',
  languagePromptTitle: 'Please choose your language',
  commonError: 'Error',
  taskLoadError: 'Loading error',
  taskTemplateResetDone: 'Template reset!',
  taskResetError: 'Reset error',
  taskDone: 'Task completed!',
  taskDeleted: 'Task deleted',
  taskDeleteError: 'Delete error',
  taskFilterTodo: 'To do',
  taskFilterCompleted: 'Completed',
  taskTemplates: 'Templates',
  taskEmpty: 'No tasks',
  taskNavToday: 'Today',
  taskNavAll: 'All',
  taskCreateTitle: 'Create task',
  taskEditTitle: 'Edit task',
  taskNameLabel: 'Task name:',
  taskNamePlaceholder: 'Task name',
  taskTagsLabel: 'Tags:',
  taskContactsLabel: 'Contacts:',
  taskChecklistLabel: 'Checklist',
  taskCreateAction: 'Create',
  taskSaveAction: 'Save',
  taskNotFound: 'Task not found',
  taskUpdateError: 'Update error',
  taskDeleteConfirm: 'Delete task?',
  taskReopened: 'Task reopened',
  taskActionResetTemplate: 'Reset template',
  taskActionComplete: 'Complete task',
  taskActionReopen: 'Reopen',
  taskActionDelete: 'Delete',
  dailyAiLimitReached: 'You have reached your daily request limit.',
  dailyAiTypedLimitReached: 'You have reached your daily limit for this request type.',
  dailyInterpretationLimitReached: 'You have reached your daily interpretation limit.',
  dailyChatLimitReached: 'You have reached your daily request limit. You can submit requests again tomorrow.',
  dailyDeepExplainLimitReached: 'You have reached your daily deep explanation limit.',
  dailyContextSearchLimitReached: 'You have reached your daily search limit.',
  dailyContextSearchStreamLimitReached: 'You have reached your daily search limit.',
  dailyVerseImageLimitReached: 'You have reached your daily verse image limit.',
  contextSearchGroupSingle: '{book} — 1 verse: {reference}',
  contextSearchGroupCount_one: '{book} — {count} verse',
  contextSearchGroupCount_other: '{book} — {count} verses',
  interpretationLoadSoftErrorTitle: 'Could not load interpretation',
};

export default en;
